import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const schema = z.object({
    Name: z.string().min(1, "Name is required"),
    Category_Id: z.string().optional(),
    Category: z.string().optional(),
    Subcategory: z.string().optional(),
    Color: z.string().optional(),
    Description: z.string().optional(),
    UnitType: z.string().optional(),
    UnitCoverage: z
        .union([z.string(), z.number()])
        .optional()
        .nullable()
        .transform((val) => {
            if (val === null || val === undefined || val === "") return null;
            const num = typeof val === "string" ? parseFloat(val) : val;
            return isNaN(num) ? null : num;
        }),
    IsActive: z.boolean().optional(),
});

const manufacturerProductResolver = zodResolver(schema);

export default manufacturerProductResolver;
